// extracted by mini-css-extract-plugin
export default {"root":"_1ZI76"};